<template>
  <div id="billingInformationSection">
    <h3 class="card-title">
      {{ $t("billing.labels.billingInformation") }}
    </h3>
    <div class="row" v-if="isLoading">
      <div class="col-md-12 card-stat">
        <loading-indicator></loading-indicator>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-12 col-xs-12">
        <div class="bg-blue-grey-100 p-30">
          <div class="counter counter-md text-xs-left" v-if="hasBillingInformation">
            <span class="counter-number grey-600">{{billingInformation.first_name}} {{billingInformation.last_name}}</span>
            <div class="counter-label m-b-5 m-t-10">
              <p v-if="team.is_reseller"><span class="p-r-10">{{billingInformation.company_name}}</span> {{ $t("billing.information.labels.taxID") }} : {{billingInformation.tax_id}}</p>
              <p>
                <span class="address1">{{billingInformation.address1}}</span>
                <span class="address2">{{billingInformation.address2}}</span>
                <span class="city">{{billingInformation.city}}</span>
                <span class="state">{{billingInformation.state}}</span>
                <span class="postal-code">{{billingInformation.zipcode}}</span>
                <span class="country">{{billingInformation.country}}</span>
              </p>
              <p>{{ $t("billing.information.labels.billingContactPhone") }} : {{billingInformation.contact_phone}}</p>
              <p>{{ $t("billing.information.labels.billingEmail") }} : {{billingInformation.contact_email}}</p>
            </div>
            <div class="counter-label text-uppercase m-b-5 m-t-20">
              <button class="btn btn-primary"
                type="button"
                v-on:click="onChangeInformationButtonClick">{{ $t("billing.information.action.changeInformation") }}
              </button>
            </div>
          </div>
          <div v-else>
            <p class="font-size-16">{{ $t("billing.information.labels.noBillingInformation") }}</p>
            <div class="counter-label text-uppercase m-b-5 m-t-20">
              <button class="btn btn-primary"
                type="button"
                v-on:click="onChangeInformationButtonClick">{{ $t("billing.information.action.addBillingInformation") }}
              </button>
            </div>
          </div>
        </div>
        <modal ref="billingInformationFormModal" class="modal-primary">
          <h4 slot="title" class="modal-title">{{ $t("billing.information.labels.enterBillingInformation") }}</h4>
          <billing-information-form
            slot="body"
            ref="billingInformationForm"
            v-bind:team="team"
            v-bind:billingInformation="billingInformation"
            v-on:save="onBillingInformationFormSaved"
            v-on:cancel="onBillingInformationFormCancel">
          </billing-information-form>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import Alert from 'components/Alert';
import Modal from 'components/Modal';
import FormGroup from 'components/forms/FormGroup';
import LoadingIndicator from 'components/LoadingIndicator';
import BillingInformationForm from 'components/forms/BillingInformationForm';

export default {
  components: {
    Alert,
    Modal,
    FormGroup,
    LoadingIndicator,
    BillingInformationForm,
  },
  props: {
    team: {
      type: Object,
    },
  },
  watch: {
    team: function(value) {
      if (value) {
        this.fetchBillingInformation();
      }
    },
  },
  data: function() {
    return {
      hasBillingInformation: false,
      isLoading: false,
      billingInformation: {
        first_name: null,
        last_name: null,
        company_name: null,
        tax_id: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zipcode: null,
        country: 'TH',
        contact_phone: null,
        contact_email: null,
      },
    };
  },
  created: function() {
    this.isLoading = true;

    this.$emit('loadChanged', true);

    this.eventHub.$on('billingInformationUpdated', (newBillingInformation) => {
      this.billingInformation = Object.assign({}, newBillingInformation);

      this.hasBillingInformation = true;

      // notify other components
      this.eventHub.$emit('hasBillingInformationUpdated', this.hasBillingInformation);
    });
  },
  mounted: function() {
    if (this.team) {
      this.fetchBillingInformation();
    }
  },
  methods: {
    fetchBillingInformation: function() {
      axios.get(`/api/teams/${this.team.namespace}/billing/info`)
      .then((response) => {
        this.isLoading = false;

        if (Array.isArray(response.data)) {
          // no billing information
          this.hasBillingInformation = false;
        } else {
          this.hasBillingInformation = true;


          this.$nextTick(() => {
            this.billingInformation = response.data;
          });
        }

        this.$emit('loadChanged', false);

        // notify other components
        this.eventHub.$emit('hasBillingInformationUpdated', this.hasBillingInformation);
      })
      .catch(() => {
        this.isLoading = false;

        // error
        this.$emit('loadChanged', false);
      });
    },
    onChangeInformationButtonClick: function() {
      this.$refs.billingInformationForm.refreshBillingInformation();
      this.$refs.billingInformationFormModal.open();
    },
    onBillingInformationFormSaved: function(newBillingInformation) {
      this.billingInformation = Object.assign({}, newBillingInformation);
      this.$refs.billingInformationFormModal.close();

      this.hasBillingInformation = true;

      swal(
          'Success',
          'Billing Information have been updated.',
          'success'
        );

      // notify other components
      this.eventHub.$emit('hasBillingInformationUpdated', this.hasBillingInformation);
    },
    onBillingInformationFormCancel: function() {
      this.$refs.billingInformationFormModal.close();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// BillingInformation.vue?c3238b56